export async function serializeBlob(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => {
            resolve(reader.result as string)
        }
        reader.onerror = reject
        reader.readAsDataURL(blob) // You can also use readAsBinaryString or readAsArrayBuffer
    })
}

export function deserializeBlob(blobString: string): Blob {
    const byteString = atob(blobString.split(',')[1])
    const mimeString = blobString.split(',')[0].split(':')[1].split(';')[0]
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
    }
    return new Blob([ab], { type: mimeString })
}


export function base64ToBlob(base64: string, mimeType: string = 'application/octet-stream'): Blob {
    // Decode the Base64 string into a binary string
    const binaryString = atob(base64)

    // Convert the binary string into a Uint8Array
    const byteArray = new Uint8Array(binaryString.length)
    for (let i = 0; i < binaryString.length; i++) {
        byteArray[i] = binaryString.charCodeAt(i)
    }

    // Create a Blob from the Uint8Array
    return new Blob([byteArray], { type: mimeType })
}
